const shadows = {
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  box: '0px 4px 16px rgba(232, 232, 232, 0.9)',
  'dark-lg':
    'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
  inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  none: 'none',
  outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  select: '0 0 0 1px #f75d8d',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
};

/**
 * @deprecated
 * You can derive the Shadows type from the DefaultChakraTheme
 *
 * type Shadows = DefaultChakraTheme['shadows']
 */
export type Shadows = typeof shadows;

export default shadows;
